import { endRoute, parentRoute } from '$shared/utils/routes';

export const referralRoutes = {
  referral: parentRoute('/referral')({
    selector: endRoute('/referral/selector'),
    details: endRoute('/referral/details'),
    confirmation: endRoute('/referral/confirmation'),
  }),
};
